/**
 * ProMeal × Cibus landing — dish selection + order flow (design 2a)
 */
(function () {
  'use strict';

  var PACKAGE_PRICE = 499;
  var PACKAGE_TARGET = 8;
  var DISCOUNT_THRESHOLD = 600;
  var DISCOUNT_AMOUNT = 100;
  var PROMO_CODE = 'CIBUS100';
  var SIDES = [];
  var STORAGE_KEY = 'cibusLandingOrder';
  var DEFAULT_COPY = {
    packageEyebrow: 'חבילת ההיכרות שלכם',
    packageTitle: 'מה מחכה לכם בחבילה',
    packageSubtitle:
      'שמונה ארוחות מלאות — הכל כלול, בלי לבחור מנות.',
    packageBanner: '🎁 החבילה כוללת את המנות הבאות',
    packageBadge: '499₪ בלבד',
    packageStepPill: 'שלב 1 מתוך 2 · תוכן החבילה',
    packageStickyLabel: '8 ארוחות · 499₪',
    packageBackToContents: 'חזרה לתוכן החבילה',
    customEyebrow: 'בניית ההזמנה שלכם',
    customTitle: 'הוסיפו את המנות שהכי מתחשק לכם',
    customSubtitle:
      'בכל הזמנה שמעל 600₪ מופעלת אוטומטית הנחת ה-100₪ הייעודית ללקוחות Cibus.',
    customBanner: 'הטבת Cibus: מעל 600₪ מקבלים 100₪ הנחה אוטומטית בקוד CIBUS100',
    customBadge: '-100₪ מעל 600₪',
    continueCta: 'המשך לסיכום ←',
    summaryTitle: 'סיכום ההזמנה',
    contactTitle: 'פרטי משלוח',
    contactNote: 'תשלום מאובטח באמצעות PayPlus + סיבוס',
    backToMenu: 'חזרה לבחירת מנות',
    submitCta: 'המשך לתשלום ←',
    submittingCta: 'מעביר לתשלום...',
    confirmTitle: 'ההזמנה שלכם נקלטה בהצלחה!',
    confirmBodyTemplate:
      'מספר הזמנה {order}. עדכון עם פרטי המשלוח יישלח אליכם ב-SMS בקרוב.',
    confirmPackageLabel: 'חבילת היכרות',
    confirmCustomLabel: 'הזמנה מותאמת אישית',
    confirmPaidLabel: 'סה"כ שולם',
    homeCta: 'חזרה לעמוד הבית ←',
    backLanding: 'חזרה',
    step1Pill: 'שלב 1 מתוך 2 · בחירת מנות',
    step2Pill: 'שלב 2 מתוך 2 · סיכום ופרטים',
    promoCode: 'CIBUS100',
  };

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function parseJsonNode(id, fallback) {
    var node = document.getElementById(id);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('Cibus landing: invalid JSON in #' + id, e);
      return fallback;
    }
  }

  function parseDishes(id) {
    var parsed = parseJsonNode(id, []);
    return Array.isArray(parsed) ? parsed : [];
  }

  function parseCopy() {
    var parsed = parseJsonNode('cibus-landing-copy', {});
    var copy = {};
    Object.keys(DEFAULT_COPY).forEach(function (key) {
      copy[key] = parsed[key] || DEFAULT_COPY[key];
    });
    return copy;
  }

  function init() {
    var root = document.getElementById('cibus-landing');
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';
    document.body.classList.add('cibus-landing-active');

    var packageDishes = parseDishes('cibus-landing-package-dishes');
    var customDishes = parseDishes('cibus-landing-dishes');
    var copy = parseCopy();
    PROMO_CODE = copy.promoCode || PROMO_CODE;
    var checkoutUrl = root.getAttribute('data-checkout-url') || '/pages/cibus-checkout';
    var packageBoxVariantId = root.getAttribute('data-package-variant-id') || '';
    var packageMealCount =
      parseInt(root.getAttribute('data-package-meal-count') || String(PACKAGE_TARGET), 10) ||
      PACKAGE_TARGET;
    var shippingIlsSetting =
      parseFloat(root.getAttribute('data-shipping-ils') || '0') || 0;
    var shippingCents = Math.round(shippingIlsSetting * 100);
    var emptyShipping = {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      address1: '',
      address2: '',
      city: '',
      zip: '',
      country: 'IL',
    };
    var state = {
      flowOpen: null,
      step: 'menu',
      qty: {},
      shipping: Object.assign({}, emptyShipping),
      errors: {},
      submitting: false,
      orderNumber: null,
    };

    var fieldKeys = [
      'first_name',
      'last_name',
      'email',
      'phone',
      'address1',
      'address2',
      'city',
      'zip',
    ];

    var els = {
      landing: $('[data-cibus-view="landing"]', root),
      flow: $('[data-cibus-view="flow"]', root),
      menu: $('[data-cibus-step="menu"]', root),
      summary: $('[data-cibus-step="summary"]', root),
      confirm: $('[data-cibus-step="confirm"]', root),
      stepPill: $('[data-cibus-step-pill]', root),
      dishGrid: $('[data-cibus-dish-grid]', root),
      menuEyebrow: $('[data-cibus-menu-eyebrow]', root),
      menuTitle: $('[data-cibus-menu-title]', root),
      menuSubtitle: $('[data-cibus-menu-subtitle]', root),
      bannerText: $('[data-cibus-banner-text]', root),
      bannerBadge: $('[data-cibus-banner-badge]', root),
      stickyLabel: $('[data-cibus-sticky-label]', root),
      progress: $('[data-cibus-progress]', root),
      continueBtn: $('[data-cibus-continue]', root),
      stickyBar: $('[data-cibus-sticky]', root),
      itemsList: $('[data-cibus-items]', root),
      totals: $('[data-cibus-totals]', root),
      submitBtn: $('[data-cibus-submit]', root),
      confirmBody: $('[data-cibus-confirm-body]', root),
      confirmLabel: $('[data-cibus-confirm-label]', root),
      confirmCount: $('[data-cibus-confirm-count]', root),
      confirmTotal: $('[data-cibus-confirm-total]', root),
      backMenuBtn: $('[data-cibus-back-menu]', root),
      backLandingBtn: $('[data-cibus-back-landing]', root),
      inputs: {},
      errorEls: {},
      fieldEls: {},
    };

    fieldKeys.forEach(function (key) {
      els.inputs[key] = root.querySelector('[data-cibus-' + key.replace(/_/g, '-') + ']');
      els.errorEls[key] = root.querySelector('[data-cibus-error="' + key + '"]');
      els.fieldEls[key] = root.querySelector('[data-cibus-field="' + key + '"]');
    });

    function activeDishes() {
      return isPackage() ? packageDishes : customDishes;
    }

    function totalCount() {
      var sum = 0;
      Object.keys(state.qty).forEach(function (id) {
        sum += state.qty[id] || 0;
      });
      return sum;
    }

    function isPackage() {
      return state.flowOpen === 'package';
    }

    function seedPackageQty() {
      var next = {};
      packageDishes.forEach(function (d) {
        var q = parseInt(d.packageQty, 10);
        next[d.id] = Number.isFinite(q) && q > 0 ? q : 1;
      });
      return next;
    }

    function derived() {
      var pkg = isPackage();
      var dishes = activeDishes();
      var count = totalCount();
      var subtotal = 0;
      var selected = [];
      dishes.forEach(function (d) {
        var q = state.qty[d.id] || 0;
        if (q > 0) {
          selected.push({ dish: d, qty: q, lineTotal: q * d.price });
          subtotal += q * d.price;
        }
      });
      var discountActive = !pkg && subtotal >= DISCOUNT_THRESHOLD;
      var discountAmount = discountActive ? DISCOUNT_AMOUNT : 0;
      var shippingIls = Math.max(0, shippingCents) / 100;
      var goodsTotal = pkg ? PACKAGE_PRICE : Math.max(0, subtotal - discountAmount);
      var finalTotal = goodsTotal + shippingIls;
      var remainingForDiscount = Math.max(0, DISCOUNT_THRESHOLD - subtotal);
      var progressPct = pkg
        ? 100
        : Math.min(100, (subtotal / DISCOUNT_THRESHOLD) * 100);
      // Gain Mass style: package always ready (box SKU), contents are display-only
      var canContinue = pkg ? true : count > 0;
      var sidebarLabel = pkg
        ? copy.packageStickyLabel
        : count + ' ארוחות בסל · סה"כ ' + subtotal + '₪';

      return {
        pkg: pkg,
        count: pkg ? packageMealCount : count,
        selected: selected,
        subtotal: subtotal,
        discountActive: discountActive,
        discountAmount: discountAmount,
        shippingIls: shippingIls,
        goodsTotal: goodsTotal,
        finalTotal: finalTotal,
        remainingForDiscount: remainingForDiscount,
        progressPct: progressPct,
        canContinue: canContinue,
        sidebarLabel: sidebarLabel,
      };
    }

    function openFlow(mode) {
      state.flowOpen = mode;
      state.step = 'menu';
      state.qty = mode === 'package' ? seedPackageQty() : {};
      state.shipping = Object.assign({}, emptyShipping);
      state.errors = {};
      state.submitting = false;
      state.orderNumber = null;
      fieldKeys.forEach(function (key) {
        if (els.inputs[key]) els.inputs[key].value = '';
      });
      window.scrollTo(0, 0);
      render();
      track('cibus_flow_open', { mode: mode });
    }

    function closeFlow() {
      state.flowOpen = null;
      state.step = 'menu';
      state.qty = {};
      state.shipping = Object.assign({}, emptyShipping);
      state.errors = {};
      state.submitting = false;
      state.orderNumber = null;
      window.scrollTo(0, 0);
      render();
    }

    function inc(id) {
      if (isPackage()) return; // fixed box — no selection
      state.qty[id] = (state.qty[id] || 0) + 1;
      render({ preserveScroll: true });
    }

    function dec(id) {
      if (isPackage()) return;
      var cur = state.qty[id] || 0;
      if (cur <= 0) return;
      if (cur - 1 <= 0) delete state.qty[id];
      else state.qty[id] = cur - 1;
      render({ preserveScroll: true });
    }

    function goToSummary() {
      if (!derived().canContinue) return;
      state.step = 'summary';
      window.scrollTo(0, 0);
      render();
      track('cibus_flow_step', { step: 'summary', mode: state.flowOpen });
    }

    function goToMenu() {
      // Keep qty + shipping — only change step (do not closeFlow / wipe order).
      syncShippingFromInputs();
      state.step = 'menu';
      state.errors = {};
      render();
      track('cibus_flow_step', { step: 'menu', mode: state.flowOpen });
    }

    function validate() {
      var errors = {};
      var s = state.shipping;
      if (!s.first_name.trim()) errors.first_name = 'נא להזין שם פרטי';
      if (!s.last_name.trim()) errors.last_name = 'נא להזין שם משפחה';
      if (!s.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.email.trim())) {
        errors.email = 'נא להזין אימייל תקין';
      }
      if (!/^0\d{8,9}$/.test(s.phone.trim().replace(/[-\s]/g, ''))) {
        errors.phone = 'נא להזין מספר טלפון תקין (לדוגמה 0501234567)';
      }
      if (!s.address1.trim()) errors.address1 = 'נא להזין כתובת';
      if (!s.city.trim()) errors.city = 'נא להזין עיר';
      return errors;
    }

    function syncShippingFromInputs() {
      fieldKeys.forEach(function (key) {
        if (els.inputs[key]) state.shipping[key] = els.inputs[key].value || '';
      });
      state.shipping.phone = String(state.shipping.phone || '').replace(/[-\s]/g, '');
      state.shipping.country = 'IL';
    }

    /* --- Delivery date: same logic as the shop drawer popup
       (component-delivery-frequency.js getClosestSundayDeliveryDate) --- */

    function getSundayOrderCutoffDateTime(deliverySundayDate) {
      // Orders for a Sunday delivery close the Thursday before, 23:59 local.
      var d = new Date(
        deliverySundayDate.getFullYear(),
        deliverySundayDate.getMonth(),
        deliverySundayDate.getDate()
      );
      d.setDate(d.getDate() - 3);
      d.setHours(23, 59, 59, 999);
      return d;
    }

    function getClosestSundayDelivery() {
      var now = new Date();
      var candidate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var day = candidate.getDay();
      if (day !== 0) {
        candidate.setDate(candidate.getDate() + (7 - day));
      }
      var afterCutoff = now >= getSundayOrderCutoffDateTime(candidate);
      if (afterCutoff) {
        candidate.setDate(candidate.getDate() + 7);
      }
      return { date: candidate, afterCutoff: afterCutoff };
    }

    function formatDeliveryDate(date) {
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0');
      return day + '/' + month;
    }

    function getDayNameHebrew(date) {
      var dayNames = {
        0: 'יום ראשון',
        1: 'יום שני',
        2: 'יום שלישי',
        3: 'יום רביעי',
        4: 'יום חמישי',
        5: 'יום שישי',
        6: 'יום שבת',
      };
      return dayNames[date.getDay()];
    }

    function buildDeliveryPayload() {
      var info = getClosestSundayDelivery();
      var d = info.date;
      var formatted = formatDeliveryDate(d);
      return {
        delivery_date_iso: d.toISOString(),
        formatted_delivery_date: getDayNameHebrew(d) + ', ' + formatted,
        delivery_date: formatted,
        delivery_frequency: 'onetime',
        translated_frequency: 'חד פעמי',
      };
    }

    function ensureDeliveryModal() {
      var modal = document.getElementById('cibus-delivery-modal');
      if (modal) return modal;
      modal = document.createElement('div');
      modal.id = 'cibus-delivery-modal';
      modal.className = 'cibus-lp__delivery-modal';
      modal.hidden = true;
      modal.innerHTML =
        '<div class="cibus-lp__delivery-overlay" data-cibus-delivery-cancel></div>' +
        '<div class="cibus-lp__delivery-sheet" role="dialog" aria-modal="true" aria-labelledby="cibus-delivery-title">' +
        '<h2 class="cibus-lp__delivery-title" id="cibus-delivery-title" data-cibus-delivery-title></h2>' +
        '<div class="cibus-lp__delivery-body" data-cibus-delivery-body></div>' +
        '<p class="cibus-lp__delivery-note">בלחיצה על הכפתור נאשר לך את מועד המשלוח ונמשיך לתשלום.</p>' +
        '<div class="cibus-lp__delivery-actions">' +
        '<button type="button" class="cibus-lp__delivery-confirm" data-cibus-delivery-confirm>אישור והמשך לתשלום ←</button>' +
        '<button type="button" class="cibus-lp__delivery-back" data-cibus-delivery-cancel>חזרה</button>' +
        '</div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-cibus-delivery-confirm]')) {
          hideDeliveryModal();
          proceedToPayment();
          return;
        }
        if (e.target.closest('[data-cibus-delivery-cancel]')) {
          hideDeliveryModal();
        }
      });
      return modal;
    }

    function showDeliveryModal() {
      var modal = ensureDeliveryModal();
      var info = getClosestSundayDelivery();
      var formatted = formatDeliveryDate(info.date);
      var titleEl = modal.querySelector('[data-cibus-delivery-title]');
      var bodyEl = modal.querySelector('[data-cibus-delivery-body]');
      if (info.afterCutoff) {
        titleEl.textContent = 'המשלוח הקרוב נסגר';
        bodyEl.innerHTML =
          '<p>ההזמנות ליום ראשון הקרוב נסגרות בכל חמישי בשעה 23:59.</p>' +
          '<p>מכיוון שהמועד עבר, המשלוח שלך יגיע ביום ראשון הבא, <strong>' +
          formatted +
          '</strong>.</p>';
      } else {
        titleEl.textContent = 'מועד המשלוח הקרוב';
        bodyEl.innerHTML =
          '<p>המשלוח שלך יגיע ביום ראשון הקרוב, <strong>' + formatted + '</strong>.</p>';
      }
      modal.hidden = false;
      document.body.classList.add('cibus-delivery-modal-open');
    }

    function hideDeliveryModal() {
      var modal = document.getElementById('cibus-delivery-modal');
      if (modal) modal.hidden = true;
      document.body.classList.remove('cibus-delivery-modal-open');
    }

    function buildPayload(d) {
      return {
        mode: state.flowOpen,
        shipping: Object.assign({}, state.shipping),
        delivery: buildDeliveryPayload(),
        items: d.selected.map(function (row) {
          return {
            id: row.dish.id,
            name: row.dish.name,
            qty: row.qty,
            price: row.dish.price,
            variantId: row.dish.variantId || null,
          };
        }),
        sides: d.pkg ? SIDES : [],
        subtotal: d.subtotal,
        discountCode: d.discountActive ? PROMO_CODE : null,
        discountAmount: d.discountAmount,
        finalTotal: d.finalTotal,
        packagePrice: d.pkg ? PACKAGE_PRICE : null,
      };
    }

    function buildCartPayloadFromShopifyCart(cart) {
      return {
        token: cart.token,
        item_count: cart.item_count,
        total_price: cart.total_price,
        items: (cart.items || []).map(function (item) {
          return {
            variant_id: item.variant_id,
            product_id: item.product_id,
            quantity: item.quantity,
            price: item.price,
            title: item.title,
            product_title: item.product_title,
            variant_title: item.variant_title,
            properties: item.properties || {},
          };
        }),
      };
    }

    function buildSyntheticCart(payload) {
      // Fallback when dishes aren't linked to Shopify yet — prices in agorot
      var items = [];
      if (payload.mode === 'package' && packageBoxVariantId) {
        items.push({
          variant_id: Number(packageBoxVariantId),
          quantity: 1,
          price: Math.round(PACKAGE_PRICE * 100),
          title: 'חבילת היכרות Cibus',
          product_title: 'חבילת היכרות Cibus',
          properties: { _main_dish_count: String(packageMealCount), _cibus_package: '1' },
        });
      } else {
        payload.items.forEach(function (item) {
          if (!item.variantId) return;
          items.push({
            variant_id: Number(item.variantId),
            quantity: item.qty,
            price: Math.round(Number(item.price) * 100),
            title: item.name,
            product_title: item.name,
            properties: {},
          });
        });
      }
      var total = items.reduce(function (sum, i) {
        return sum + i.price * i.quantity;
      }, 0);
      return {
        token: 'cibus-landing',
        item_count: items.reduce(function (n, i) {
          return n + i.quantity;
        }, 0),
        total_price: total,
        items: items,
      };
    }

    function addToCart(payload) {
      function failSoft(reason, detail) {
        console.warn('Cibus landing cart add soft-fail:', reason, detail || '');
        return { ok: false, reason: reason, detail: detail || '' };
      }

      function postCartAdd(items) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: items }),
        }).then(function (res) {
          return res.text().then(function (raw) {
            var data = {};
            try {
              data = raw ? JSON.parse(raw) : {};
            } catch (e) {}
            if (!res.ok) {
              var msg =
                (data && (data.description || data.message)) ||
                raw ||
                ('HTTP ' + res.status);
              return failSoft('cart_add_failed', String(msg).slice(0, 240));
            }
            return { ok: true, data: data };
          });
        });
      }

      if (payload.mode === 'package' && packageBoxVariantId) {
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
        })
          .then(function () {
            return postCartAdd([
              {
                id: Number(packageBoxVariantId),
                quantity: 1,
                properties: {
                  _main_dish_count: String(packageMealCount),
                  _cibus_package: '1',
                },
              },
            ]);
          })
          .catch(function (err) {
            return failSoft('cart_add_failed', err && err.message);
          });
      }

      var lines = payload.items
        .filter(function (item) {
          return item.variantId;
        })
        .map(function (item) {
          return { id: Number(item.variantId), quantity: item.qty };
        });

      if (!lines.length) return Promise.resolve(failSoft('no_variants'));

      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
      })
        .then(function () {
          return postCartAdd(lines);
        })
        .then(function (result) {
          if (!result.ok || !payload.discountCode) return result;
          return fetch('/discount/' + encodeURIComponent(payload.discountCode), {
            method: 'GET',
            credentials: 'same-origin',
          })
            .then(function () {
              return result;
            })
            .catch(function () {
              return result;
            });
        })
        .catch(function (err) {
          return failSoft('cart_add_failed', err && err.message);
        });
    }

    function startPayPlus(payload) {
      return addToCart(payload).then(function (result) {
        if (result && result.ok) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              return buildCartPayloadFromShopifyCart(cart);
            });
        }
        // Cart add can fail (inventory / unpublished / selling plan) — still charge via PayPlus
        var synthetic = buildSyntheticCart(payload);
        if (!synthetic.items.length) {
          var detail = (result && result.detail) || '';
          throw new Error(
            detail
              ? 'לא ניתן להוסיף לעגלה: ' + detail
              : 'לא ניתן להתחיל תשלום — חברו מוצרים לחבילה / למנות בעורך התבנית.',
          );
        }
        return synthetic;
      }).then(function (cartPayload) {
        return fetch('/apps/cibus-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            cart: cartPayload,
            shipping: payload.shipping,
            shipping_cost_agorot: shippingCents,
            delivery: payload.delivery,
          }),
        }).then(function (res) {
          return res.text().then(function (raw) {
            var data = {};
            try {
              data = raw ? JSON.parse(raw) : {};
            } catch (e) {
              throw new Error('תשובת שרת לא תקינה (' + res.status + ')');
            }
            if (!res.ok || !data.payment_page_link) {
              throw new Error(data.error || 'שגיאה ביצירת קישור תשלום');
            }
            return data;
          });
        });
      });
    }

    function submitOrder() {
      syncShippingFromInputs();
      state.errors = validate();
      if (Object.keys(state.errors).length) {
        render();
        var firstKey = Object.keys(state.errors)[0];
        if (els.inputs[firstKey]) els.inputs[firstKey].focus();
        return;
      }
      // Same UX as the shop drawer: confirm the next delivery date before payment.
      showDeliveryModal();
    }

    function proceedToPayment() {
      if (state.submitting) return;
      state.submitting = true;
      render();

      var d = derived();
      var payload = buildPayload(d);
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}

      startPayPlus(payload)
        .then(function (data) {
          track('cibus_order_submit', {
            mode: payload.mode,
            total: payload.finalTotal,
            discountApplied: !!payload.discountCode,
            payplus: true,
          });
          window.location.href = data.payment_page_link;
        })
        .catch(function (err) {
          console.error('Cibus landing PayPlus failed', err);
          state.submitting = false;
          render();
          alert((err && err.message) || 'שגיאה ביצירת תשלום. נסו שוב.');
        });
    }

    function track(eventName, props) {
      try {
        if (window.dataLayer) window.dataLayer.push(Object.assign({ event: eventName }, props || {}));
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(eventName, props || {});
        }
      } catch (e) {}
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function wrapMoneyTexts() {
      root.querySelectorAll('[data-cibus-money-text]').forEach(function (el) {
        if (el.dataset.moneyWrapped === '1') return;
        el.dataset.moneyWrapped = '1';
        el.innerHTML = el.innerHTML.replace(
          /(\d[\d,]*)\s*₪/g,
          '<span class="cibus-lp__money" dir="ltr">$1₪</span>'
        );
      });
    }

    function setupCarousel(track, opts) {
      if (!track) return;
      opts = opts || {};
      var wrap = track.closest('[data-cibus-carousel-wrap]');
      var dotsHost = wrap ? wrap.querySelector('[data-cibus-carousel-dots]') : null;
      var highlightActive = track.classList.contains('cibus-lp__steps');

      function slides() {
        return Array.prototype.filter.call(track.children, function (node) {
          return node.nodeType === 1;
        });
      }

      function activeIndex() {
        var list = slides();
        if (!list.length) return 0;
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var best = 0;
        var bestDist = Infinity;
        list.forEach(function (slide, i) {
          var rect = slide.getBoundingClientRect();
          var dist = Math.abs(rect.left + rect.width / 2 - center);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function syncActive(index) {
        var list = slides();
        if (!highlightActive) return;
        list.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
      }

      function renderDots() {
        var active = activeIndex();
        syncActive(active);
        if (!dotsHost) return;
        var list = slides();
        if (list.length < 2) {
          dotsHost.innerHTML = '';
          dotsHost.hidden = true;
          return;
        }
        dotsHost.hidden = false;
        var html = '';
        list.forEach(function (_, i) {
          html +=
            '<button type="button" class="cibus-lp__carousel-dot' +
            (i === active ? ' is-active' : '') +
            '" data-cibus-carousel-go="' +
            i +
            '" aria-label="שקופית ' +
            (i + 1) +
            '"></button>';
        });
        dotsHost.innerHTML = html;
      }

      function centerSlide(index, smooth) {
        var list = slides();
        var slide = list[index];
        if (!slide) return;
        var trackRect = track.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        var delta =
          slideRect.left + slideRect.width / 2 - (trackRect.left + trackRect.width / 2);
        var target = track.scrollLeft + delta;
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
        } else {
          track.scrollLeft = target;
        }
        syncActive(index);
      }

      if (!track._cibusCarouselBound) {
        track._cibusCarouselBound = true;
        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              renderDots();
            });
          },
          { passive: true }
        );
        if (dotsHost) {
          dotsHost.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-cibus-carousel-go]');
            if (!btn) return;
            var index = parseInt(btn.getAttribute('data-cibus-carousel-go'), 10);
            centerSlide(index, true);
          });
        }
        window.addEventListener('resize', function () {
          centerSlide(activeIndex(), false);
          renderDots();
        });
      }

      requestAnimationFrame(function () {
        if (opts.preserveScroll) {
          if (typeof opts.scrollLeft === 'number') {
            track.scrollLeft = opts.scrollLeft;
          }
          renderDots();
          return;
        }
        // Fresh open: start on first slide
        centerSlide(0, false);
        renderDots();
      });
    }

    function initCarousels() {
      root.querySelectorAll('[data-cibus-carousel]').forEach(setupCarousel);
    }

    function renderDishGrid(d, opts) {
      if (!els.dishGrid) return;
      opts = opts || {};
      var preserveScroll = !!opts.preserveScroll;
      var scrollLeft = preserveScroll ? els.dishGrid.scrollLeft : null;
      var dishes = activeDishes();
      var html = '';
      dishes.forEach(function (dish) {
        var qty = state.qty[dish.id] || 0;
        html +=
          '<article class="cibus-lp__dish' +
          (d.pkg ? ' cibus-lp__dish--fixed' : '') +
          '">';
        html += '<div class="cibus-lp__dish-media">';
        html +=
          '<img src="' +
          escapeHtml(dish.imageUrl) +
          '" alt="' +
          escapeHtml(dish.name) +
          '" loading="lazy" width="800" height="600">';
        html += '<span class="cibus-lp__dish-tag">' + escapeHtml(dish.tag) + '</span>';
        html += '</div>';
        html += '<div class="cibus-lp__dish-body">';
        html += '<div class="cibus-lp__dish-name">' + escapeHtml(dish.name) + '</div>';
        html +=
          '<div class="cibus-lp__dish-macros">' +
          dish.kcal +
          ' קלוריות · ' +
          dish.protein +
          " גר' חלבון</div>";
        html += '<div class="cibus-lp__dish-row">';
        if (d.pkg) {
          // Gain Mass style: show what's in the box — no quantity controls
          html += '<span class="cibus-lp__dish-included">כלול בחבילה</span>';
          if (qty > 1) {
            html += '<span class="cibus-lp__dish-fixed-qty">× ' + qty + '</span>';
          }
        } else {
          html +=
            '<span class="cibus-lp__dish-price">' +
            dish.price +
            '₪<span> / מנה</span></span>';
          if (qty > 0) {
            html += '<div class="cibus-lp__qty">';
            html +=
              '<button type="button" class="cibus-lp__qty-btn cibus-lp__qty-btn--dec" data-cibus-dec="' +
              escapeHtml(dish.id) +
              '" aria-label="הפחתה">−</button>';
            html += '<span class="cibus-lp__qty-val" aria-live="polite">' + qty + '</span>';
            html +=
              '<button type="button" class="cibus-lp__qty-btn cibus-lp__qty-btn--inc" data-cibus-inc="' +
              escapeHtml(dish.id) +
              '" aria-label="הוספה">+</button>';
            html += '</div>';
          } else {
            html +=
              '<button type="button" class="cibus-lp__add-btn" data-cibus-inc="' +
              escapeHtml(dish.id) +
              '">הוספה +</button>';
          }
        }
        html += '</div></div></article>';
      });
      if (d.pkg && dishes.length === 0) {
        html +=
          '<p class="cibus-lp__dish-empty">תוכן החבילה יעודכן בקרוב. ניתן להמשיך להזמנה.</p>';
      }
      els.dishGrid.innerHTML = html;
      setupCarousel(els.dishGrid, {
        preserveScroll: preserveScroll,
        scrollLeft: scrollLeft,
      });
    }

    function renderSummary(d) {
      if (!els.itemsList) return;
      var html = '';
      d.selected.forEach(function (row) {
        html += '<div class="cibus-lp__item">';
        html += '<div class="cibus-lp__item-main">';
        html +=
          '<img src="' +
          escapeHtml(row.dish.imageUrl) +
          '" alt="' +
          escapeHtml(row.dish.name) +
          '">';
        html += '<div><div class="cibus-lp__item-name">' + escapeHtml(row.dish.name) + '</div>';
        html += '<div class="cibus-lp__item-qty">× ' + row.qty + '</div></div></div>';
        if (!d.pkg) {
          html += '<div class="cibus-lp__item-total">' + row.lineTotal + '₪</div>';
        }
        html += '</div>';
      });
      if (d.pkg) {
        SIDES.forEach(function (side) {
          html += '<div class="cibus-lp__item">';
          html += '<div class="cibus-lp__item-main">';
          html += '<div class="cibus-lp__gift-thumb" aria-hidden="true">🎁</div>';
          html += '<div class="cibus-lp__item-name">' + escapeHtml(side) + '</div>';
          html += '</div><div class="cibus-lp__gift-tag">במתנה</div></div>';
        });
      }
      els.itemsList.innerHTML = html;

      var totalsHtml = '';
      if (!d.pkg) {
        totalsHtml +=
          '<div class="cibus-lp__totals-row"><span>סכום ביניים</span><span>' +
          d.subtotal +
          '₪</span></div>';
        if (d.discountActive) {
          totalsHtml +=
            '<div class="cibus-lp__totals-row cibus-lp__totals-row--bold"><span>קוד הטבה ' +
            PROMO_CODE +
            ' ✓</span><span>−' +
            d.discountAmount +
            '₪</span></div>';
        } else {
          totalsHtml +=
            '<div class="cibus-lp__totals-hint">עוד ' +
            d.remainingForDiscount +
            '₪ להזמנה ומקבלים 100₪ הנחה עם קוד ' +
            PROMO_CODE +
            '</div>';
        }
      } else {
        totalsHtml +=
          '<div class="cibus-lp__totals-row"><span>חבילת היכרות</span><span>' +
          PACKAGE_PRICE +
          '₪</span></div>';
      }
      if (d.shippingIls > 0) {
        totalsHtml +=
          '<div class="cibus-lp__totals-row"><span>משלוח</span><span>' +
          d.shippingIls +
          '₪</span></div>';
      }
      totalsHtml += '<div class="cibus-lp__totals-divider"></div>';
      totalsHtml +=
        '<div class="cibus-lp__totals-row cibus-lp__totals-row--final"><span>סה"כ לתשלום</span><span>' +
        d.finalTotal +
        '₪</span></div>';
      els.totals.innerHTML = totalsHtml;

      fieldKeys.forEach(function (key) {
        var hasErr = !!state.errors[key];
        if (els.fieldEls[key]) {
          els.fieldEls[key].classList.toggle('cibus-lp__field--error', hasErr);
        }
        if (els.errorEls[key]) {
          els.errorEls[key].textContent = state.errors[key] || '';
          els.errorEls[key].hidden = !hasErr;
        }
      });
      if (els.submitBtn) {
        els.submitBtn.textContent = state.submitting
          ? copy.submittingCta || 'מעביר לתשלום...'
          : copy.submitCta || 'המשך לתשלום ←';
        els.submitBtn.style.opacity = state.submitting ? '0.6' : '1';
        els.submitBtn.disabled = !!state.submitting;
      }
    }

    function renderConfirm(d) {
      if (els.confirmBody) {
        els.confirmBody.textContent = String(copy.confirmBodyTemplate || '').replace(
          '{order}',
          state.orderNumber || '',
        );
      }
      if (els.confirmLabel) {
        els.confirmLabel.textContent = d.pkg
          ? copy.confirmPackageLabel
          : copy.confirmCustomLabel;
      }
      if (els.confirmCount) els.confirmCount.textContent = d.count + ' ארוחות';
      if (els.confirmTotal) els.confirmTotal.textContent = d.finalTotal + '₪';
    }

    function render(opts) {
      opts = opts || {};
      var open = !!state.flowOpen;
      if (els.landing) els.landing.hidden = open;
      if (els.flow) els.flow.hidden = !open;
      if (!open) return;

      var d = derived();
      var step = state.step;
      if (els.menu) els.menu.hidden = step !== 'menu';
      if (els.summary) els.summary.hidden = step !== 'summary';
      if (els.confirm) els.confirm.hidden = step !== 'confirmation';
      if (els.stickyBar) els.stickyBar.hidden = step !== 'menu';
      if (els.stepPill) {
        els.stepPill.hidden = step === 'confirmation';
        if (step === 'menu') {
          els.stepPill.textContent = d.pkg ? copy.packageStepPill : copy.step1Pill;
        } else {
          els.stepPill.textContent = copy.step2Pill;
        }
      }
      // Top "חזרה": exit flow on menu; on summary go back to dishes without reset.
      if (els.backLandingBtn) {
        if (step === 'summary') {
          var summaryBack = d.pkg ? copy.packageBackToContents : copy.backToMenu;
          els.backLandingBtn.textContent = String(summaryBack || copy.backLanding || '')
            .replace(/\s*[←→]\s*/g, '')
            .trim();
        } else {
          els.backLandingBtn.textContent = String(copy.backLanding || '')
            .replace(/\s*[←→]\s*/g, '')
            .trim();
        }
      }

      if (d.pkg) {
        if (els.menuEyebrow) els.menuEyebrow.textContent = copy.packageEyebrow;
        if (els.menuTitle) els.menuTitle.textContent = copy.packageTitle;
        if (els.menuSubtitle) els.menuSubtitle.textContent = copy.packageSubtitle;
        if (els.bannerText) els.bannerText.textContent = copy.packageBanner;
        if (els.bannerBadge) els.bannerBadge.textContent = copy.packageBadge;
      } else {
        if (els.menuEyebrow) els.menuEyebrow.textContent = copy.customEyebrow;
        if (els.menuTitle) els.menuTitle.textContent = copy.customTitle;
        if (els.menuSubtitle) els.menuSubtitle.textContent = copy.customSubtitle;
        if (els.bannerText) {
          els.bannerText.textContent = String(copy.customBanner || '').replace(
            /CIBUS100/g,
            PROMO_CODE,
          );
        }
        if (els.bannerBadge) els.bannerBadge.textContent = copy.customBadge;
      }

      if (step === 'menu') {
        renderDishGrid(d, { preserveScroll: !!opts.preserveScroll });
        if (els.stickyLabel) els.stickyLabel.textContent = d.sidebarLabel;
        if (els.progress) els.progress.style.width = d.progressPct + '%';
        if (els.continueBtn) {
          els.continueBtn.disabled = !d.canContinue;
          els.continueBtn.style.opacity = d.canContinue ? '1' : '0.4';
        }
      } else if (step === 'summary') {
        renderSummary(d);
        if (els.backMenuBtn) {
          var backLabel = d.pkg ? copy.packageBackToContents : copy.backToMenu;
          els.backMenuBtn.textContent = String(backLabel || '').replace(/\s*[←→]\s*/g, '').trim();
        }
      } else if (step === 'confirmation') {
        renderConfirm(d);
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cibus-open]');
      if (t) {
        openFlow(t.getAttribute('data-cibus-open'));
        return;
      }
      if (e.target.closest('[data-cibus-back-landing]')) {
        // Summary → dish menu (keep order). Menu → leave flow to landing.
        if (state.step === 'summary') {
          goToMenu();
        } else {
          closeFlow();
        }
        return;
      }
      if (e.target.closest('[data-cibus-back-menu]')) {
        goToMenu();
        return;
      }
      if (e.target.closest('[data-cibus-continue]')) {
        goToSummary();
        return;
      }
      if (e.target.closest('[data-cibus-submit]')) {
        submitOrder();
        return;
      }
      if (e.target.closest('[data-cibus-home]')) {
        closeFlow();
        return;
      }
      var incBtn = e.target.closest('[data-cibus-inc]');
      if (incBtn) {
        inc(incBtn.getAttribute('data-cibus-inc'));
        return;
      }
      var decBtn = e.target.closest('[data-cibus-dec]');
      if (decBtn) {
        dec(decBtn.getAttribute('data-cibus-dec'));
      }
    });

    fieldKeys.forEach(function (key) {
      if (!els.inputs[key]) return;
      els.inputs[key].addEventListener('input', function () {
        state.shipping[key] = els.inputs[key].value || '';
        if (state.errors[key]) {
          delete state.errors[key];
          if (els.fieldEls[key]) els.fieldEls[key].classList.remove('cibus-lp__field--error');
          if (els.errorEls[key]) els.errorEls[key].hidden = true;
        }
      });
    });

    function relocateFreshTechSection() {
      var how = root.querySelector('.cibus-lp__how');
      var closing = root.querySelector('.cibus-lp__closing');
      var fresh = document.querySelector('.pm-fig-fresh');
      if (!how || !fresh) return;
      var sectionEl = fresh.closest('[id^="shopify-section-"]');
      if (!sectionEl) return;
      // Place homepage Skin Pack block under how-it-works, before closing CTA
      if (closing && closing.parentNode === how.parentNode) {
        how.parentNode.insertBefore(sectionEl, closing);
      } else {
        how.insertAdjacentElement('afterend', sectionEl);
      }
    }

    relocateFreshTechSection();
    wrapMoneyTexts();
    initCarousels();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
